import { queryOptions } from '@tanstack/react-query';

import { queryKeys } from '@/hooks/api/query-keys';

import { getCalendarDefaults } from './calendar-defaults-server';

export function calendarDefaultsQueryOptions(userId: string) {
  return queryOptions({
    queryKey: queryKeys.calendarDefaults.byUserId(userId),
    queryFn: () => getCalendarDefaults(),
  });
}
